var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { makeImmutable } from "../../core";
import { perRestaurant } from "../../di";
import { memo } from "../../utils";
import { Price } from "../Price";
import { productInstanceKey, } from "../ProductInstance";
import { HalvesPricing } from "./HalvesPricing";
import { ModifierInstancePriceService } from "./ModifierInstancePriceService";
import { ParameterScopeProvider } from "../ParameterScopeProvider";
let ProductInstancePurePriceService = class ProductInstancePurePriceService {
    constructor(modifierInstancePriceService, parameterScopeProvider) {
        this.modifierInstancePriceService = modifierInstancePriceService;
        this.parameterScopeProvider = parameterScopeProvider;
        makeImmutable(this);
    }
    price(productInstance, fulfillmentMethod) {
        return memo([productInstanceKey(fulfillmentMethod, productInstance)], () => this.productInstancePrice(productInstance, fulfillmentMethod));
    }
    productInstancePrice(productInstance, fulfillmentMethod) {
        const parameterScope = this.parameterScopeProvider.fromProductInstance(productInstance, fulfillmentMethod);
        const commonPrice = Price.total(productInstance.commonModifierInstances.objects.map((modifierInstance) => this.modifierInstancePriceService.price(modifierInstance, parameterScope)));
        const partsPrice = this.productInstancePartsPrice(productInstance.parts, parameterScope);
        return partsPrice.add(commonPrice);
    }
    productInstancePartsPrice(productInstanceParts, parameterScope) {
        switch (productInstanceParts.type) {
            case "SinglePart":
                return this.singleProductInstancePartPrice(productInstanceParts, parameterScope);
            case "Halves":
                return this.productInstanceHalvesPrice(productInstanceParts, parameterScope);
        }
    }
    productInstancePartBasePrice(productInstancePart, parameterScope) {
        return Price.scoped(productInstancePart.productType.pricing, parameterScope);
    }
    singleProductInstancePartPrice(productInstancePart, parameterScope) {
        const { part } = productInstancePart;
        const basePrice = this.productInstancePartBasePrice(part, parameterScope);
        const configPrice = Price.total(part.modifierInstances.objects.map((modifierInstance) => this.modifierInstancePriceService.price(modifierInstance, parameterScope)));
        return basePrice.add(configPrice);
    }
    productInstanceHalvesPrice(productInstanceHalves, parameterScope) {
        const { first, second, productCategory } = productInstanceHalves;
        const firstBasePrice = this.productInstancePartBasePrice(first, parameterScope);
        const secondBasePrice = this.productInstancePartBasePrice(second, parameterScope);
        const basePrice = new HalvesPricing(productCategory.divisiblePricePolicy).price(firstBasePrice, secondBasePrice);
        const firstConfigPrice = Price.total(first.modifierInstances.objects.map((modifierInstance) => this.modifierInstancePriceService.price(modifierInstance, parameterScope)));
        const secondConfigPrice = Price.total(second.modifierInstances.objects.map((modifierInstance) => this.modifierInstancePriceService.price(modifierInstance, parameterScope)));
        const configPrice = firstConfigPrice.add(secondConfigPrice).half();
        return basePrice.add(configPrice);
    }
};
ProductInstancePurePriceService = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof ModifierInstancePriceService !== "undefined" && ModifierInstancePriceService) === "function" ? _a : Object, typeof (_b = typeof ParameterScopeProvider !== "undefined" && ParameterScopeProvider) === "function" ? _b : Object])
], ProductInstancePurePriceService);
export { ProductInstancePurePriceService };
